import { Step } from 'react-joyride';

export const TOURS: Record<string, Step[]> = {
  'design-sessions': [
    {
      target: '[data-tour="feedback-fab"]',
      content: 'We\'ve added AI-powered design sessions! After you submit feedback, you\'ll see a new "Refine with AI" button.',
      placement: 'left' as const,
      disableBeacon: true,
    },
    {
      target: '[data-tour="feedback-fab"]',
      content: 'The AI will ask clarifying questions, then generate a user story and wireframe for your idea — making it easier for us to build exactly what you need.',
      placement: 'left' as const,
    },
    {
      target: '[data-tour="feedback-fab"]',
      content: 'Try it now! Click the feedback button, submit a feature request or bug report, and look for "Refine with AI" in the success message.',
      placement: 'left' as const,
    },
  ],
};
